import script from "./NastaPills.vue?vue&type=script&lang=ts&setup=true"
export * from "./NastaPills.vue?vue&type=script&lang=ts&setup=true"

import "./NastaPills.vue?vue&type=style&index=0&id=0db2d696&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db2d696"]])

export default __exports__